import type { MainPoint } from "../../../../types/global"
import { api } from "../../api"

export async function loadMainpoints(): Promise<MainPoint[]> {
    let mainpoints = await api<MainPoint[]>("mainpoint", {})
    return mainpoints.data
}
